import { jsx as _jsx } from "react/jsx-runtime";
import MuiLink from '@mui/material/Link';
import * as React from 'react';
import { usePaletteColor } from '../theme';
import { prepareTextTransform } from '../typography';
export const Link = React.forwardRef((props, ref) => {
    const { color = 'primary', variant, textTransform, textOverflow, overflow, whiteSpace, children, ...muiProps } = props;
    const paletteColor = usePaletteColor(color);
    const cssTextTransform = textTransform === 'sentence' ? undefined : textTransform;
    const resolvedVariant = variant ?? 'body2';
    return (_jsx(MuiLink, { ref: ref, underline: "hover", ...muiProps, variant: resolvedVariant, sx: {
            color: paletteColor,
            '&:hover': {
                color: paletteColor
            },
            cursor: props.onClick ? 'pointer' : undefined,
            textTransform: cssTextTransform,
            textOverflow,
            overflow,
            whiteSpace,
            ...muiProps.sx
        }, children: prepareTextTransform(children, textTransform) }));
});
